<template>
  <el-form
    ref="form"
    :model="form"
    :rules="rules"
    :label-position="labelPosition"
    label-width="100px"
  >
    <el-form-item
      label="规则名称"
      prop="ruleName"
    >
      <el-input
        placeholder="请输入"
        v-model="form.ruleName"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="推送策略"
      prop="strategyId"
    >
      <el-select
        style="width: 100%"
        v-model="form.strategyId"
        placeholder="请选择"
      >
        <el-option
          v-for="item in pushStrategyOption"
          :key="item.id"
          :label="item.label"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      label="推送渠道"
      prop="pushChannel"
    >
      <el-select
        style="width: 100%"
        v-model="form.pushChannel"
        placeholder="请输入"
        @change="pushChannelChange"
      >
        <el-option
          v-for="item in pushChannelOption"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      label="推送配置"
      prop="pushConfig"
    >
      <el-select
        style="width: 100%"
        v-model="form.pushConfig"
        placeholder="请选择"
        @change="pushConfigChange"
      >
        <el-option
          v-for="item in pushConfigOptionComputed"
          :key="item.id"
          :label="getLabel(item)"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      v-if="form.pushChannel== 9"
      label="受众配置"
      prop="receiverId"
    >
      <el-select
        style="width: 100%"
        v-model="form.receiverId"
        placeholder="请选择"
      >
        <el-option
          v-for="item in lineGroup"
          :key="item.id"
          :label="item.groupName"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      v-if="form.pushChannel == 10"
      label="QQ接收方"
      prop="receiverId"
    >
      <el-select
        style="width: 100%"
        v-model="form.receiverId"
        placeholder="请选择"
        filterable
      >
        <el-option
          v-for="item in qqReceivers"
          :key="item.receiverId"
          :label="getQqReceiverLabel(item)"
          :value="item.receiverId"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      label="失效日期"
      prop="expireDate"
    >
      <el-date-picker
        style="width: 100%;"
        v-model="form.expireDate"
        type="date"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        placeholder="失效日期"
      >
      </el-date-picker>
    </el-form-item>
    <el-form-item
      v-if="form.pushChannel== 1"
      label="受众标签"
      prop="peopleTag"
    >
      <el-select
        style="width: 100%"
        v-model="form.peopleTag"
        placeholder="请选择"
        multiple
      >
        <el-option
          v-for="item in peopleTagOption"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      v-if="form.pushChannel== 5"
      label="受众群体"
      prop="peopleType"
    >
      <el-select
        v-model="form.peopleType"
        placeholder="请选择接收人类型"
        @change="peopleTypeChange"
      >
        <el-option label="好友" value="1"></el-option>
        <el-option label="群组" value="2"></el-option>
        <el-option label="好友标签" value="3"></el-option>
      </el-select>
      <el-select
        v-model="form.peopleIds"
        multiple
        placeholder="请选择接收人"
      >
        <el-option
          v-for="item in peopleList"
          :key="item.id"
          :label="getUserLabel(item)"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      v-if="form.pushChannel== 2 || form.pushChannel== 3"
      label="受众群号"
      prop="peopleGroupNo"
    >
      <el-input
        placeholder="请输入"
        v-model="form.peopleGroupNo"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="推送签名"
      prop="titlePrefix"
    >
      <el-input
        placeholder="请输入"
        v-model="form.titlePrefix"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="状态"
      prop="status"
    >

      <el-radio-group
        v-model="form.status"
      >
        <el-radio :label="1">启用</el-radio>
        <el-radio :label="0">禁用</el-radio>
      </el-radio-group>
      <!-- </el-radio-group>
          <el-radio
            v-model="form.status"
            label="1"
          >启用</el-radio>
          <el-radio
              v-model="form.status"
              label="0"
          >禁用</el-radio> -->
    </el-form-item>
  </el-form>
</template>

<script>
import { queryPushTab } from '@/api/user'
import {handlerChannelConfig} from "@/utils";
import formLabalPosition from "@/mixins/formLabalPosition";
import { getList } from "@/api/sys/robitConfig/dingding";
import { getWechatPublicNoMsgTplList,getTelegramRobitList,getLarkRobitList,getEnterpriseWeChatRobitList,getFeishuRobitList } from '@/api/sys/messagePushRule'
import { getQqConfigList, getQqReceivers } from '@/api/sys/robitConfig/qq'
let originForm = {
  ruleName: '',
  strategyId: '',
  pushChannel: '',
  pushConfig: '',
  peopleTag: [],
  peopleGroupNo: '',
  peopleType:'',
  peopleIds:[],
  titlePrefix: '',
  status: 1,
  expireDate: '',
  receiverId:''
}
export default {
  name: "pushRuleForm",
  props: {
    formData:{
      type: Object,
      default(){
        return {}
      }
    },
  },

  data() {
    return {
      form: JSON.parse(JSON.stringify(originForm)),
      rules:{
        ruleName: [
          { required: true, message: '请选择规则名称', trigger: 'blur' },
        ],
        strategyId:[
          { required: true, message: '请选择', trigger: 'blur' },
        ],
        pushChannel:[
          { required: true, message: '请选择', trigger: 'change' },
        ],
        pushConfig:[
          { required: true, message: '请选择', trigger: 'change' },
        ],
        peopleTag:[
          { required: true, message: '请选择', trigger: 'change' },
        ],
        peopleGroupNo:[
          { required: true, message: '请选择', trigger: 'blur' },
        ],
        receiverId:[
          { required: true, message: '请选择', trigger: 'change' },
        ],
        expireDate:[
          // { required: true, message: '请选择', trigger: 'change' },
        ],
      },

      agencyNameOption: [],
      pushStrategyOption: [],
      pushChannelOption: [
        /*{id: 1,label: '公众号'},
        {id: 4,label: '企业微信'},
        {id: 2,label: 'Telegram'},
        {id: 3,label: 'Lark应用'},
        {id: 5,label: '微信机器人'},
        {id: 6,label: '飞书机器人'},
        {id: 7,label: '钉钉机器人'},
        {id: 8, label: 'MT4通知'},*/

      ],
      tplTitleOption: [],
      telegramRobotOption: [],
      larkRobotOption: [],
      dingdingRobotOption: [],
      feishuRobotOption: [],
      wxBotList:[],
      wxAccountList:[],
      mt4Options: [],
      ChannelLines:[],
      peopleList:[],
      lineGroup:[],
      qqRobotOption: [],
      qqReceivers: [],
      enterpriseWeChatRobotOption: [],
      peopleTagOption: [],
    }
  },
  watch:{
    formData:{
      handler(newVal){
        if(newVal.id){
          this.assign(newVal);
          this.pushConfigOptionComputed.forEach(item => {
            if(item.id == this.form.pushConfig){
              this.getLineGroup(item.channelId)
            }
          });
        }
      },
      deep:true
    }
  },
  mixins: [formLabalPosition],
  computed: {
    pushConfigOptionComputed(){
      switch (this.form.pushChannel){
        case 1:
          return this.tplTitleOption;
        case 2:
          return this.telegramRobotOption;
        case 3:
          return this.larkRobotOption;
        case 4:
          return this.enterpriseWeChatRobotOption;
        case 5:
          return this.wxBotList;
        case 6:
          return this.feishuRobotOption;
        case 7:
          return this.dingdingRobotOption;
        case 8:
          return this.mt4Options;
        case 9:
          return this.ChannelLines ;
        case 10:
          return this.qqRobotOption;
      }
    }
  },
  created(){
    if(this.formData.id){
      this.assign(this.formData);
    }

    this.getPushChannel();
    this.getPushStrategyList();

  },
  methods:{

    getPushChannel(){
      queryPushTab().then((res) => {
        console.log(res);
        // 1-微信公众号 2-telegram 3-Lark应用 4-企业微信 5-个人微信 6-Lark机器人 7-钉钉机器人 8-MT4
        /*for (let i = 0; i < res.channelTypes.length; i++) {
          switch (res.channelTypes[i]){
            case 1:
              this.pushChannelOption.push({label: '微信公众号',id: 1});
              break;
            case 2:
              this.pushChannelOption.push({label: 'Telegram',value: 2});
              break;
            case 3:
              this.pushChannelOption.push({label: 'Lark应用',value: 3});
              break;
            case 4:
              this.pushChannelOption.push({label: '企业微信',value: 4});
              break;
            case 5:
              this.pushChannelOption.push({label: '个人微信',value: 5});
              break;
            case 6:
              this.pushChannelOption.push({label: 'Lark机器人',value: 6});
              break;
            case 7:
              this.pushChannelOption.push({label: '钉钉',value: 7});
              break;
            case 8:
              this.pushChannelOption.push({label: 'MT4',value: 8});
              break;
          }
        }*/
        this.numberChannelTypes = res.channelTypes;
        handlerChannelConfig(res.channelTypes,this.pushChannelOption);
        this.$forceUpdate();
        this.authGetList();
      })
    },
    authGetList(){
      if(this.numberChannelTypes.includes(1)){
        this.getWechatPublicNoTpl();
      }
      if(this.numberChannelTypes.includes(2)){
        this.getTeleRobitList();
      }
      if(this.numberChannelTypes.includes(3)){
        this.getLarkRobitList();
      }
      if(this.numberChannelTypes.includes(4)){
        this.getWechatRobitList();
      }
      if(this.numberChannelTypes.includes(5)){
        this.getWxBotList();
      }
      if(this.numberChannelTypes.includes(6)){
        this.getFeishuRobitList();
      }
      if(this.numberChannelTypes.includes(7)){
        this.getDingdingRobitList();
      }
      if(this.numberChannelTypes.includes(8)){
        this.getMt4Notice();
      }
      if(this.numberChannelTypes.includes(9)){
        this.getLines();
      }
      if(this.numberChannelTypes.includes(10)){
        this.getQqRobotList();
      }
    },
    assign(newVal){
      if(this.larkRobotOption.length==0){
        this.authGetList();
        this.getPushStrategyList();
      }
      this.form.id = newVal.id;
      this.form.ruleName = newVal.ruleName;
      this.form.strategyId = newVal.strategyId;
      this.form.pushChannel = newVal.channelType;
      this.form.pushConfig = newVal.senderId;
      this.form.receiverId = newVal.channelType == 9 ? parseFloat(newVal.receiverId) : (newVal.receiverId || '');
      if(newVal.channelType == 1){
        if(newVal.receiverId){
          this.form.peopleTag = JSON.parse(newVal.receiverId)
        }
        this.tplTitleOption.forEach(item => {
          if(item.id == newVal.senderId){
            this.form.peopleType = item.appid
            this.getTagsList(item.appid)
          }
        });
      }else if(newVal.channelType== 2 || newVal.channelType== 3){
        this.form.peopleGroupNo = newVal.receiverId;
      }else if(newVal.channelType == 5){
        let temp = JSON.parse(newVal.receiverId)
        this.form.peopleType=temp.type
        this.form.peopleIds =temp.ids
        this.getDataList(this.form.peopleType)
      }else if(newVal.channelType == 10){
        this.getQqReceiverList(newVal.senderId)
      }
      this.form.titlePrefix = newVal.titlePrefix;
      this.form.status = newVal.status;
      this.form.expireDate = newVal.expireDate;
      this.$forceUpdate();
    },
    getDataList(dataType){
      if(dataType){
        let url=''
        let params = {
          'page': 1,
          'limit': 10000,
          'botId': this.form.pushConfig
        };
        switch (dataType) {
          case "1":
            url = '/wx/manage/wxBotClientFriend/list';
            break;
          case "2":
            url = '/wx/manage/wxBotClientGroup/list';
            break;
          case "3":
            url = '/wx/manage/wxBotClientTag/list';
            break;
        }
        this.$http({
          url: url,
          method: 'get',
          params:params
        }).then((res) => {
          this.peopleList = [];
          if (res && res.code === 200) {
            this.peopleList = res.page.list
          }
        })

      }
    },
    getPushStrategyList() {
      this.$http({
        url: '/wx/manage/forwardStrategy/list',
        method: 'get',
        params: {
          'page': 1,
          'limit': 10000,
          'status': 1,
        }
      }).then((res) => {
        this.pushStrategyOption = [];
        if (res && res.code === 200) {
          res.page.list.forEach(element => {
            let sourceName = element.sourceType!=2?element.sourceOfficialName:element.sourceNickname
            let temp ={
              id:element.id,
              label:element.strategyName +'-Source:'+sourceName+'-Author:' + element.authorNickName
            }
            this.pushStrategyOption.push(temp)
          });

        }
      })
    },
    getWxBotList() {
      this.$http({
        url: '/wx/manage/wxBotClientInfo/list',
        method: 'get',
        params: {
          'page': 1,
          'limit': 10000,
          'botStatus': 1
        }
      }).then((res) => {
        if (res && res.code === 200) {
          this.wxBotList = res.page.list
        }
      })
    },
    getWxAccountList() {
      this.$http({
        url: '/wx/manage/wxAccount/list',
        method: 'get',
        params: null
      }).then((res) => {

        if (res && res.code === 200) {
          this.wxAccountList = res.list
        }
      })
    },
    // mt4通知
    getMt4Notice(){
      this.$http({
        url: '/wx/manage/mt4Notifier/list',
        method: 'get',
        params: {
          'page': 1,
          'limit': 500,
          'sidx': 'id',
          'sort': 'desc'
        }
      }).then((data) => {
        if (data.code === 200) {
          this.mt4Options = data.page.list
        } else {
          this.mt4Options = [];
        }
      })
    },

    getLines(){
      this.$http({
        url: '/wx/manage/lineChannel/list',
        method: 'get',
        params: {
          'page': 1,
          'limit': 500,
          'sidx': 'id',
          'sort': 'desc'
        }
      }).then((data) => {
        if (data.code === 200) {
          this.ChannelLines = data.page.list
        } else {
          this.ChannelLines = [];
        }
      })
    },
    getQqRobotList(){
      getQqConfigList({
        page: 1,
        limit: 500,
        status: 1,
        sidx: 'id',
        order: 'desc'
      }).then((data) => {
        this.qqRobotOption = data && data.code === 200 ? data.page.list : [];
      })
    },
    getQqReceiverList(id){
      this.qqReceivers = [];
      if(!id) return;
      getQqReceivers(id).then((data) => {
        if(this.form.pushChannel == 10 && this.form.pushConfig == id && data && data.code === 200){
          this.qqReceivers = data.receivers || [];
        }
      })
    },
    pushChannelChange(){

      this.form.pushConfig = ''
      this.form.peopleType = ''
      this.form.receiverId = ''
      this.qqReceivers = []
    },
    peopleTypeChange(value){
      if(this.form.pushChannel == 5){
        this.form.peopleIds = [];
        this.getDataList(value)
      }
    },
    pushConfigChange(value){
      //重置
      this.form.receiverId = "";
      if(this.form.pushChannel == 1){
        this.form.peopleTag=[]
        this.tplTitleOption.forEach(item => {
          if(item.id == value){
            this.form.peopleType = item.appid
            this.getTagsList(item.appid)
          }
        });
      }else if(this.form.pushChannel == 5){
        this.form.peopleIds=[]
        this.getDataList(this.form.peopleType)
      }else if(this.form.pushChannel == 9){
        this.pushConfigOptionComputed.forEach(item => {
          if(item.id == value){
            this.getLineGroup(item.channelId)
          }
        });
      }else if(this.form.pushChannel == 10){
        this.getQqReceiverList(value)
      }
    },
    getWechatPublicNoTpl(){
      getWechatPublicNoMsgTplList().then((res) => {
        let resData = res.page;
        this.tplTitleOption = resData.list;
        this.tplTitleOption.forEach(item => {
          if(item.id == this.form.pushConfig){
            this.form.peopleType = item.appid
            this.getTagsList(item.appid)
          }
        });
      })
    },
    getTeleRobitList(){
      getTelegramRobitList().then((res) => {
        let resData = res.page;
        // 仅展示具备推送能力的 bot（botRole=2 推送 / 3 两者）
        this.telegramRobotOption = (resData.list || []).filter(
          item => item.botRole === 2 || item.botRole === 3
        );
        if(this.form.pushChannel == 2){
          this.pushConfigOptionComputed =  this.telegramRobotOption;
        }
      })
    },
    getLarkRobitList(){
      getLarkRobitList().then((res) => {
        let resData = res.page;
        this.larkRobotOption = resData.list;
        if(this.form.pushChannel == 3){
          this.pushConfigOptionComputed =  this.larkRobotOption;
        }
      })
    },
    getDingdingRobitList(){
      getList(
        {
          page: 1,
          limit: 500,
        }
      ).then((res) => {
        this.dingdingRobotOption = res.page.list;
        if(this.form.pushChannel == 7){
          this.pushConfigOptionComputed =  this.dingdingRobotOption;
        }
      });
    },
    getFeishuRobitList(){
      getFeishuRobitList().then((res) => {
        let resData = res.page;
        this.feishuRobotOption = resData.list;
        if(this.form.pushChannel == 6){
          this.pushConfigOptionComputed =  this.feishuRobotOption;
        }
      })
    },
    getWechatRobitList(){
      getEnterpriseWeChatRobitList().then((res) => {
        let resData = res.page;
        this.enterpriseWeChatRobotOption = resData.list;
        if(this.form.pushChannel == 4){
          this.pushConfigOptionComputed =  this.enterpriseWeChatRobotOption;
        }
      })
    },
    getTagsList(appid){
      this.$http({
        url: '/wx/manage/wxUserTags/listWithoutCookie',
        method: 'get',
        params: {
          'appid' : appid
        }
      }).then((data) => {
        console.log('推送签名',data);
        if (data.code === 200) {
          this.peopleTagOption = data.list
        }
      })
    },

    getLineGroup(id){
      this.$http({
        url: '/wx/manage/lineGroup/list',
        method: 'get',
        params: {
          'channelId' : id,
          'status':1
        }
      }).then((data) => {
        console.log('推送签名',data);
        if (data.code === 200) {
          this.lineGroup = data.page.list
        }
      })
    },
    getLabel(item){
      if(this.form.pushChannel == 1){
        return item.title+'-'+item.appName;
      }else if(this.form.pushChannel == 2 || this.form.pushChannel == 4 || this.form.pushChannel == 6){
        return item.name;
      }else if(this.form.pushChannel == 3){
        return item.appName;
      }else if(this.form.pushChannel == 5){
        return item.botName+'-'+item.nickname;
      }
      if(this.form.pushChannel == 7){
        return item.name;
      }
      if(this.form.pushChannel == 8){
        return item.name;
      }
      if(this.form.pushChannel == 9){
        return item.channelName;
      }
      if(this.form.pushChannel == 10){
        return item.name;
      }
    },
    getQqReceiverLabel(item){
      return item.receiverName ? `${item.receiverName} (${item.receiverId})` : item.receiverId;
    },
    getUserLabel(item){
      if(this.form.peopleType == 1){
        return item.nickname;
      }else if(this.form.peopleType == 2){
        return item.groupName;
      }else if(this.form.peopleType == 3){
        return item.tagName;
      }
    },
    reset(){
      this.form = {
        ...originForm,
      };
    },
    selfValidate(){
      this.$refs.form.validate((valid) => {
        if(valid){
          this.$emit('submit',this.form);
        }else {
          console.log('no-pass')
        }
      })
    },
    selfClear(){
      this.$refs.form.clearValidate();
      this.$refs.form.resetFields();
      this.reset();
    }
  },
}
</script>

<style scoped>

</style>
